import moment from 'moment';
import { LevelOfService } from '../types/LevelOfService';

export const TIME_FORMAT_WITH_SECONDS = 'HH:mm:ss';
export const TIME_FORMAT = 'HH:mm';
export const DATETIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
export const MIN_MAP_ZOOM_BEFORE_CLUSTER = 10;
export const INTERSECTION_CACHE_EXPIRATION_TIME = moment.duration(7, 'days');
export const ORANGE_ICON_URL = 'https://maps.google.com/mapfiles/ms/icons/orange-dot.png';
export const BLUE_ICON_URL = 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png';
export const YELLOW_ICON_URL = 'https://maps.google.com/mapfiles/ms/icons/yellow-dot.png';

export const IS_DEV_VERSION = (window.location.href.match('dev') || !window.location.href.match(
  'appspot',
));

export const CHART_GRID_TOP_MARGIN = 35;
export const CHART_GRID_BOTTOM_MARGIN = 40;

export const USE_DARK_MODE = (localStorage.getItem('darkMode') === 'true');

/**
 * The regex to match states' intersections that should be accessible to each organization.
 */
export const ORGANIZATION_STATE_MAP: { [key: string]: RegExp } = {
  Caltrans: /CA/i,
  CTDOT: /CT/i,
  Default: /IN/i,
  GDOT: /GA/i,
  INDOT: /IN/i,
  JTRP: /./i,
  MnDOT: /MN/i,
  NCDOT: /NC/i,
  ODOT: /OH/i,
  PennDOT: /PA/i,
  Testing: /IN/i,
  TxDOT: /TX/i,
  UDOT: /UT/i,
  WisDOT: /WI/i,
};

export const TITLE_MAP = {
  aog: 'Arrival on Green',
  sf: 'Split Failures',
  dsb: 'Downstream Blockage',
  los: 'Level of Service',
};

export const LEVELS_OF_SERVICE: { [key: string]: LevelOfService } = {
  A: {
    max: 10,
    color: '#CCFF99',
  },
  B: {
    min: 10,
    max: 20,
    color: '#7FEA33',
  },
  C: {
    min: 20,
    max: 35,
    color: '#EFEA5B',
  },
  D: {
    min: 35,
    max: 55,
    color: '#F9B731',
  },
  E: {
    min: 55,
    max: 80,
    color: '#EF4309',
  },
  F: {
    min: 80,
    color: '#D30202',
  },
};

export const LOADING_MESSAGE = 'If you see this for more than a couple seconds, third-party '
  + 'cookies may not be allowed for this site. '
  + '<b>Check the far right of the URL bar for a cookie or eye icon, click "'
  + '<i>Site not working?</i>", then " <i>Allow cookies</i>". '
  + '</b>Otherwise, check'
  + '<a href="https://www.123formbuilder.com/docs/how-to-enable-third-party-cookies-in-your-web-browser/"> '
  + 'this help article</a>.';

export const ECHARTS_LOADING_OPTION = {
  text: 'Gathering data... This may take a bit.',
  fontSize: 20,
  textColor: (USE_DARK_MODE) ? '#fff' : '#000',
  maskColor: (USE_DARK_MODE) ? 'rgba(0,0,0,0.8)' : 'rgba(255, 255, 255, 0.8)',
  fontWeight: 'bold',
  spinnerRadius: 25,
  lineWidth: 5,
};
